

























import { Component, Mixins, Prop, Watch } from 'vue-property-decorator'
import { VueCropper } from 'vue-cropper'

// Mixins
import Logo from '@/mixins/Logo'

// Components
import ModalWrapper from '@/components/common/ModalWrapper.vue'
import ImageViewer from '@/components/common/ImageViewer.vue'
import InfoBox from '@/components/common/InfoBox.vue'

@Component({
  components: {
    ModalWrapper,
    ImageViewer,
    InfoBox,
    VueCropper
  }
})
export default class LogoUploader extends Mixins(Logo) {
  $refs: {
    cropper: any
  }

  image = null
  cropped = null

  modalActive: boolean = false

  data = null
  dataOutput = null

  @Prop({ default: null }) logoID

  @Prop({ default: false }) reloadImage

  @Prop({ default: false }) isLoading

  @Watch('image')
  openModal(file) {
    if (file) {
      this.modalActive = true
    }
  }

  get isEmpty() {
    return this.logoID ? false : true
  }

  close() {
    this.image = null
    this.modalActive = false
  }

  emit(file) {
    this.data = null
    const image = file
    const reader = new FileReader()
    reader.addEventListener('load', () => {
      // this.$refs.croppie.bind({ url: reader.result })
      this.data = reader.result
      // console.log(reader)
    })
    // reader.onload = (e) => {
    //   let data
    // }
    reader.readAsDataURL( image )
  }

  parseOutput(base64) {
    this.cropped = base64
    return base64.split('base64,')[1]
  }

  submit() {
    this.$refs.cropper.getCropData((data) => {
      this.dataOutput = data
      this.$emit('submit', this.parseOutput(data))
    })
    this.modalActive = false
  }
}
